export default __webpack_public_path__ + "static/media/multi-languages.4a201ff1.svg";